// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

	$w("#vectorImage1").onClick(()=>{

		if( $w("#section4").collapsed ) {
		$w("#section4").expand();
		}
		else {
		$w("#section4").collapse();
		}

	});

});